import { Card, Col, Divider, Flex, Row, Space, Button } from "antd";
import { Info, InfoSwitch } from "components/elements";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatTimes, formatUnit } from "utils/formatter";
import styles from "../styles/CompanyProfile.module.css";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"

function CompanyOvertimeView({ currentOvertime = {}, onEdit = () => { }, convertMinutesToTimeWithSeconds = {} }) {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const { otReqCondition = {}, breakPeriodType = {} } = currentOvertime;


  return (
    <Space className={styles.container} size={24} direction="vertical">
      {
        roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|CONDITION") &&
        <Row justify="end">
          <Button onClick={onEdit} type="primary"
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
            <Flex align="center" justify="center" gap={8}>
              <EditIcon />
              {t("common.edit").toUpperCase()}
            </Flex>
          </Button>
        </Row>
      }

      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("overtime_condition.label.withdrawal_request")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("overtime_condition.label.minimum_period_required")}
              value={formatTimes(currentOvertime.minimumRequired)}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("overtime_condition.label.document_limit_per_day")}
              value={
                currentOvertime.docLimitPerDay &&
                  currentOvertime.docLimitPerDay !== "0" &&
                  currentOvertime.docLimitPerDay !== " "
                  ? formatUnit(+currentOvertime.docLimitPerDay, {
                    singular: t('employee.document.header'),
                    plural: t('documents'),
                  })
                  : t('unlimited-1')
              }
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("overtime_condition.label.overtime_request_condition")}
              value={
                i18n.language === "en"
                  ? otReqCondition.nameEn
                  : otReqCondition.name
              }
            />
          </Col>
          <Col span={12}>
            <Flex>
              {otReqCondition.nameEn === "Must withdraw in advance" && (
                <Info
                  label={t("overtime_condition.label.advance_atLeast")}
                  value={
                    otReqCondition.nameEn === "Must withdraw in advance" ? formatUnit(currentOvertime?.advanceAtLeast, {
                      singular: t('unit.day'),
                      plural: t('translation.unit.days'),
                    }) : "-"}
                />
              )}
            </Flex>

            <Flex>
              {otReqCondition.nameEn === "To be withdrawn retrospectively" && (
                <Info
                  label={t("overtime_condition.label.advance_less_than")}
                  value={otReqCondition.nameEn === "To be withdrawn retrospectively" ? formatUnit(currentOvertime?.advanceLessThan, {
                    singular: t('unit.day'),
                    plural: t('translation.unit.days'),
                  }) : "-"}
                />
              )}
            </Flex>
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t("overtime_condition.label.permanent_employees_only")}
              value={currentOvertime.permanentEmployeesOnly === "Y"}
              disabled
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("overtime_condition.label.condition")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("overtime_condition.label.break_period_type")}
              value={
                i18n.language === "en"
                  ? breakPeriodType?.nameEn
                  : breakPeriodType?.name
              }
            />
          </Col>
          <Col span={12}></Col>

          {
            currentOvertime?.breakPeriodType?.name === 'หักต่อเนื่อง' ?

              <Col span={12}>
                <Info
                  label={t("overtime_condition.label.break_period")}
                  value={formatTimes(currentOvertime?.breakPeriod)}
                />
              </Col>
              : currentOvertime?.breakPeriodType?.name === 'ไม่หักเวลาพัก' ?
                null :
                <Col span={12}>
                  <Info
                    label={t("overtime_condition.label.break_period")}
                    value={formatTimes(currentOvertime?.breakPeriod)}
                  />
                </Col>
          }
          {
            currentOvertime?.breakPeriodType?.name === 'ไม่หักเวลาพัก' ? null :
              currentOvertime?.breakPeriodType?.name === 'หักครั้งเดียว' ?
                <Col span={12}>
                  <Info
                    label={t("overtime_condition.label.working_period_before_start_break_deduction")}
                    value={formatTimes(currentOvertime?.workingPeriodBeforeStartBreakDeduction)}
                  />
                </Col> : <Col span={12}>
                  <Info
                    label={t("overtime_condition.label.break_deduction_every_working_period")}
                    value={formatTimes(currentOvertime?.breakDeductionEveryWorkingPeriod)}
                  />
                </Col>
          }
          {/* <Col span={23}>
            <InfoSwitch
              label={t("overtime_condition.label.overtime_rounding")}
              value={currentOvertime.otRounding === "Y"}
              disabled
            />
          </Col> */}
          <Col span={12}>
            <Info
              label={t("overtime_condition.label.calculate_overtime_in_every")}
              value={
                currentOvertime.otRounding === "Y" ? formatTimes(convertMinutesToTimeWithSeconds(currentOvertime?.calculateOtEvery)) : "-"}
            />
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t(
                "overtime_condition.label.limir overtime hours per weerk"
              )}
              value={currentOvertime?.limitovertimePerWeek === "Y"}
              disabled
            />
          </Col>
          {currentOvertime?.limitovertimePerWeek === "Y" ?
            <Col span={12}>
              <Info
                label={t("overtime_condition.label.maximun number of hours per week")}
                value={currentOvertime?.maximunnumberofhoursperweek ? formatTimes(convertMinutesToTimeWithSeconds(currentOvertime?.maximunnumberofhoursperweek)) : "-"}
              />
            </Col>
            : null
          }
          <Col span={23}>
            <InfoSwitch
              label={t("overtime_condition.label.calculate_overtime_holiday")}
              value={currentOvertime.calculateOtHolidayByShift === "Y"}
              disabled
            />
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t("overtime_condition.label.deduct_break_holiday")}
              value={currentOvertime.deductBreakHolidayShift === "Y"}
              disabled
            />
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t(
                "overtime_condition.label.allow_overtime_uncomplete_workdays"
              )}
              value={currentOvertime.allowOtUnCompleteDays === "Y"}
              disabled
            />
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t(
                "overtime_condition.label.pay_overtime_fully_on_flexible_shifts"
              )}
              value={currentOvertime.payOtFlexShifts === "Y"}
              disabled
            />
          </Col>
        </Row>
      </Card>

      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("overtime_condition.label.condition_ot_request")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={23}>
            <InfoSwitch
              label={t(
                "overtime_condition.label.not_allow_emp_request_ot"
              )}
              value={currentOvertime?.employeeRequest === "Y"}
              disabled
            />
          </Col>
          <Col span={23}>
            <InfoSwitch
              label={t(
                "overtime_condition.label.allow_sup_request_ot"
              )}
              value={currentOvertime?.supervisorRequest === "Y"}
              disabled
            />
          </Col>
        </Row>
      </Card>
    </Space>
  );
}

export default CompanyOvertimeView;
